import ApiService from "@/utils/request"

export const merchantServe = {
  list(params) {
    return ApiService.post(`merchant/navPage/`, params)
  },
  detail(id) {
    return ApiService.query(`merchant/${id}/`)
  },
  apply(id) {
    return ApiService.post(`merchant/preferential/`, {
      merchantPreferentialServiceInfoId: id
    })
  },
  preferential(params) {
    return ApiService.query(`merchant/preferential/list/`, params)
  },
  preferentialDetail(id) {
    return ApiService.query(`merchant/preferential/${id}/`)
  },
  preferentialVerification(id, code) {
    return ApiService.post(`merchant/preferential/verification/`, {
      preferentialId: id,
      verificationCode: code
    })
  },
  getTalentInfo() {
    return ApiService.query(`talent/`)
  },
  division() {
    return ApiService.get(`merchant/division/`)
  },
  preferentialLevel() {
    return ApiService.post(`merchant/preferentialLevel/`)
  },
  preferentialEvaluate(params) {
    return ApiService.post(`merchant/preferential/mark`, params)
  },
  getPreferentialEvaluate(id) {
    return ApiService.query(`merchant/preferential/${id}/mark`)
  },
  allServiceInfo(id) {
    return ApiService.query(`merchant/serviceInfo/${id}`)
  }
}

export const merchantOperatorServe = {
  merchantList() {
    return ApiService.query(`merchantOperator/merchantList`)
  },
  serviceList(params) {
    return ApiService.query(`merchantOperator/serviceList`, params)
  },
  report(params) {
    return ApiService.query(`merchant/report`, params)
  }
}
